import { IFeatureFlags, IServiceRequestFlags } from './common';
import flagsData from './flags';
import { Data } from '@telstra-connect/utils';
import { FeatureFlagsHelper } from '@telstra-connect/feature-flags';

let helper: FeatureFlagsHelper<typeof Data.serviceRequestAppName>;

export const loadServiceRequestsFeatureFlags = (getFlagsConfigFromState?: () => IServiceRequestFlags) => {
    helper = new FeatureFlagsHelper(Data.serviceRequestAppName, getFlagsConfigFromState, flagsData);
};

export const loadApplicationAccessRole = () => {
    if (getServiceRequestFlags().featureFlags && getServiceRequestFlags().featureFlags.customProperties
        && getServiceRequestFlags().customProperties) {
        const role = Boolean(Data.applicationRole[getServiceRequestFlags().customProperties.roles]);
        return role;
    }
    return true;
};

export const getServiceRequestFlags: () => IFeatureFlags = () => helper && helper.getFlags();
